import { createAction } from 'redux-act';
import { ICommentsState } from '../reducers/comments';
import {
  IDeleteCommentAction,
  IDictionary,
  IDisableCollectionCommentsAction,
  IFetchCommentCountsParams,
  IFetchImageCommentsParams,
  IFetchImageCommentsSuccessAction
} from '../types';

export const fetchCommentCounts = createAction<IFetchCommentCountsParams>();
export const fetchCommentCountsSuccess = createAction<IDictionary<number>>();
export const fetchImageComments = createAction<IFetchImageCommentsParams>();
export const fetchImageCommentsSuccess = createAction<IFetchImageCommentsSuccessAction>();
export const deleteComment = createAction<IDeleteCommentAction>();
export const deleteCommentSuccess = createAction<IDeleteCommentAction>();
export const changeCommentsState = createAction<Partial<ICommentsState>>();
export const disableCollectionComments = createAction<IDisableCollectionCommentsAction>();
